import { render } from "./SectionTitle.vue?vue&type=template&id=df7e6bea"
const script = {}

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__